<template>
	<div class="view edit-view">
		<HeaderBar>
			<van-button size="mini" @click="submitEdit" type="primary">完成修改</van-button>
		</HeaderBar>
		<div class="view__wrap">
			<div class="content-wrap">
			<div class="avatar-wrap">
<!--			<van-uploader class="avatar-wrap"-->
<!--						  :after-read="onImgRead">-->
				<img v-if="!!avatar"
					 class="avatar-img"
					 :src="avatar" />
				<img v-else
					 class="avatar-img"
					 src="../../assets/images/default_avatar.png" />
<!--			</van-uploader>-->
				<img class="camera-img" src="../../assets/images/camera_small.png" @click="uploadImg"/>
			</div>
			<div class="content-wrap--inner">
				<div class="item-wrap name-wrap">
					<span v-show="!nameFieldVisible">{{ nickname }}</span>
					<van-field v-show="nameFieldVisible"
							   placeholder="姓名"
							   class="field-blank value text--sub"
							   v-model="nickname"
							   @blur="nameFieldVisible = false"></van-field>
					<img class="edit-icon"
						 v-show="!nameFieldVisible"
						 src="../../assets/images/edit_small.png"
						 @click="nameFieldVisible = !nameFieldVisible" />
				</div>
				<div class="item-wrap industry-wrap">
					<div class="field">
						<img class="field-icon"
							 src="../../assets/images/location.png" />
						<span>所在行业</span>
					</div>
					<div class="field-blank field-industry"
						 @click="pickerWrapVisible=true">
						<span v-if="!industryObj"
							  class="placeholder">请选择</span>
						<span v-else>{{industryObj.industry_name}}</span>
						<img class="sel-img"
							 src="../../assets/images/sel.png" />
					</div>
				</div>
				<div class="item-wrap company-wrap">
					<div class="field">
						<img class="field-icon"
							 src="../../assets/images/company.png" />

						<span>所在公司</span>
					</div>
					<van-field class="field-blank value text--sub"
							   v-model="company"></van-field>
				</div>
				<div class="item-wrap job-wrap">
					<div class="field">
						<img class="field-icon"
							 src="../../assets/images/job.png" />

						<span>职位</span>
					</div>
					<van-field class="field-blank value text--sub"
							   v-model="job"></van-field>
				</div>
				<div class="item-wrap gender-wrap">
					<div class="field">
						<img class="field-icon"
							 src="../../assets/images/gender.png" />

						<span>性别</span>
					</div>
					<van-radio-group class="value text--sub"
									 v-model="gender">
						<van-radio :name="1">男</van-radio>
						<van-radio :name="2">女</van-radio>
					</van-radio-group>
				</div>
				<div class="item-wrap introduction-wrap"
					 id="fieldPanel">
					<div class="field">
						<img class="field-icon"
							 src="../../assets/images/intro.png" />

						<span>介绍</span>
					</div>
					<van-field autosize
							   class="field-blank--introduction value text--sub"
							   v-model="introduction"
							   type="textarea"
							   @focus="onFocus"></van-field>
				</div>
			</div>

		</div>
		</div>
		
		<div class="picker-wrap"
			 v-show="pickerWrapVisible">
			<div class="picker-wrap--inner">
				<div class="btn-wrap">
					<span class="cancel-btn"
						  @click="pickerWrapVisible = false">取消</span>
					<span class="ok-btn"
						  @click="onPickerOkClick">确定</span>
				</div>
				<mt-picker class="industry-picker"
						   :slots="industrySlots"
						   @change="onPickerChange"
						   valueKey="industry_name"
						   :itemHeight="50"></mt-picker>
			</div>

		</div>
	</div>
</template>

<script>
import { Button, Field, Uploader, RadioGroup, Radio } from 'vant';
import { Toast, Picker } from 'mint-ui'

import apiUtil from '../../utils/apiUtil';
import {replaceEmoji, checkEmoji } from '../../utils/regexUtil'
import apiConst from '../../consts/apiConst';
import HeaderBar from '../../components/HeaderBar';
export default {
	name: 'edit',
	components: {
		'van-button': Button,
		'van-field': Field,
		'van-uploader': Uploader,
		'van-radio-group': RadioGroup,
		'van-radio': Radio,
		'mt-picker': Picker,
		HeaderBar
	},
	data() {
		return {
			nameFieldVisible: false,
			avatar: '',
			company: '',
			introduction: '',
			job: '',
			nickname: '',
			gender: 1,
			pIndustry: null,
			industry: null,
			industryObj: null, // 提交的是这个的id
			industrySlots: [],
			industryList: [],
			pickerWrapVisible: false
		};
	},
	created() {

		this.init();
	},
	mounted(){
		window.uploadCallBack=this.uploadCallBack;
	},
	methods: {
		validate(){
			let {nickname, company, job} = this;
			// if(!nickname || !company || !job){
			// 	Toast({
			// 		message: '请将信息填写完整',
			// 		duration: 1000,
			// 	});
			// 	return false;
			// }
			if(nickname.length > 20){
				Toast({
					message: '昵称长度须小于20个字符',
					duration: 1000,
				});
				return false;
			}
			if(company.length > 20){
				Toast({
					message: '所在公司长度须小于20个字符',
					duration: 1000,
				});
				return false;
			}
			if(job.length > 20){
				Toast({
					message: '职位长度须小于20个字符',
					duration: 1000,
				});
				return false;
			}
			return true;
		},

		async init() {
			await this.getIndustry();
			const res = await apiUtil.post(apiConst.getProfile);
			if (res.success) {
				const {
					avatar,
					company,
					company_address,
					introduction,
					job,
					nickname,
					industry
				} = res;
				this.avatar = avatar;
				this.company = company;
				this.introduction = introduction;
				this.job = job;
				this.nickname = nickname;
				this.findIndustryById(industry)
			}
		},

		findIndustryById(id) {
			for (let pInd of this.industryList) {
				for (let ind of pInd.sub_cate) {
					if (ind.id === parseInt(id)) {
						this.pIndustry = pInd;
						this.industry = ind;
						this.industryObj = ind;
						break;
					}
				}
			}
		},

		async onImgRead(file) {
			const res = await apiUtil.form(apiConst.submitImg, {
				cover: file.file,
				type: 1
			});
			if (res.success) {
				const { url } = res;
				this.avatar = url;
				this.$nextTick(()=>{
					this.submitEdit()
				})
			}
		},
		uploadImg(){
			window.HostApp.takePhoto('uploadCallBack')

		},
		uploadCallBack(cb){
			this.avatar = cb;
			// this.$nextTick(()=>{
			// 	this.submitEdit()
			// })
		},
		async submitEdit() {
			if(!this.validate()){
				return;
			}
			let industry=this.industryObj?this.industryObj.id:'';
			const res = await apiUtil.post(apiConst.submitProfile, {
				avatar: this.avatar,
				company: this.company,
				introduction: this.introduction,
				job: this.job,
				nickname: this.nickname,
				gender: this.gender,
				industry: industry,
			});
			if (res.success) {
				Toast({
					message: '信息已修改',
					duration: 1000,
					background: '#8FC31E'
				});
				setTimeout(() => {
			        this.$router.push('/my');
			    }, 1200);
				
			}
		},

		async getIndustry() {
			const res = await apiUtil.post(apiConst.getIndustry);
			if (res.success) {
				this.industryList = res.list
				this.industrySlots = [{
					flex: 1,
					values: res.list,
					className: 'slot1',
					textAlign: 'center'
				}, {
					flex: 1,
					values: res.list.length > 0 ? res.list[0].sub_cate : [],
					className: 'slot2',
					textAlign: 'center'
				}]
			}
		},

		// onFieldBlur() {

		// 	this.nameFieldVisible = false;
		// 	this.$nextTick(() => {


		// 		this.submitEdit()
		// 	})
		// },


		onPickerChange(picker, values) {
			if (values.length > 0 && (!this.pIndustry || values[0].id !== this.pIndustry.id)) {
				picker.setSlotValues(1, values[0].sub_cate)
				this.pIndustry = values[0]
			} else if (values.length > 0 && (!this.industry || values[1].id !== this.industry.id)) {
				this.industry = values[1]
			}
		},

		onPickerOkClick() {
			this.industryObj = this.industry
			this.pickerWrapVisible = false;
			// this.$nextTick(() => {
			// 	this.submitEdit()
			// })
		},

		onFocus() {
			setTimeout(() => {
				const panel = document.getElementById('fieldPanel')
				panel.scrollIntoView(true)
				panel.scrollIntoViewIfNeeded()
			}, 200)
		}
	}
};
</script>

<style lang="stylus" scoped>
.edit-view {
	height: 100%;

	background: url('../../assets/images/edit_bg.png') center center;
	background-size: cover;
	overflow-y: auto;
  	-webkit-overflow-scrolling: touch;
	.view__wrap{
		display: flex;

		.content-wrap {
		position: relative;
		width: 680px;
		height: 950px;
		margin: 140px auto;
		padding: 90px 100px 0;
		box-shadow: 0px 18px 26px -16px rgba(189, 202, 217, 1);
		border: 1px solid rgba(241, 241, 241, 1);
		background-color: #fff;
		border-radius: 4PX;

		.avatar-wrap {
			position: absolute;
			width: 157px;
			height: 157px;
			border: 7px solid #fff;
			left: 78px;
			top: -78px;
			background-color: #fff;
			border-radius: 50%;
			overflow: hidden;
			background-clip: padding-box;
			border-top-left-radius: 999px; /* 左上角 */
		    border-top-right-radius: 999px; /* 右上角 */
		    border-bottom-right-radius: 999px; /* 右下角 */
		    border-bottom-left-radius: 999px; /* 左下角 */
		    border-radius: 999px;

			.avatar-img {
				display: block;
				width: 150px;
				height: 150px;
				position: absolute;
				left: 0;
				top: 0;
				right: 0;
				bottom: 0;
				margin: auto;
			}

			.camera-img{
				width: 60px;
				height: 60px;
				position: absolute;
				bottom: 0px;
				margin-left: -30px;
				left: 50%;
				z-index: 9;
			}
		}

		.content-wrap--inner {
			height: 780px;
			overflow-y: auto;

			.item-wrap {
				margin-top: 20px;

				.field {
					display: flex;
					align-items: center;
					color: #8FC31E;
					font-size: 32px;
					margin-bottom: 10px;

					.field-icon {
						width: 40px;
						height: 40px;
						margin-right: 10px;
					}
				}

				.field-blank {
					width: 430px;
					height: 50px;
					border-radius: 15px;
					border: 1PX solid rgba(238, 238, 238, 1);
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 10px;

					.placeholder {
						color: #999;
						font-size: 30px;
					}

					&.field-industry {
						.sel-img {
							width: 26px;
							height: 13px;
						}
					}
				}

				.field-blank--introduction {
					width: 430px;
					background: rgba(238, 238, 238, 1);
					border-radius: 15px;
				}
				
			}

			.name-wrap {
				display: flex;
				align-items: center;
				font-size: 40px;
				color: #333;
				margin-bottom: 40px;
				.edit-icon {
					width: 40px;
					height: 40px;
					margin-left: 10px;
				}
			}

			.gender-wrap {
				.value {
					display: flex;

					.van-radio {
						overflow: initial;
						margin-right: 20px;
					}
				}
			}
		}
	}
	}
	

	.picker-wrap {
		position: fixed;
		top: 90px;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 9;
		background-color: rgba(0, 0, 0, 0);

		.picker-wrap--inner {
			position: absolute;
			height: 500px;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: #fff;
		}

		.btn-wrap {
			padding: 0 35px;
			height: 78px;
			background-color: #eee;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 30px;
			color: #666;

			.ok-btn {
				color: #8FC31E;
			}
		}

		.industry-picker {
			.picker-item {
			}
		}
	}
}
</style>
